// extracted by mini-css-extract-plugin
export default {"arrow":"x0ky5","arrowTop":"ojRp3","arrowBottom":"Aj7x1","arrowLeft":"o8F8d","arrowRight":"NXjtZ"};